import { useStyles } from "./myLearningStyle";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { HEADER_CLICK_TYPES, MyLearning_Link_Paths } from "utils/constants";
import { Badge, Button } from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import TelegramIcon from "@mui/icons-material/Telegram";
import AssignmentIcon from "@mui/icons-material/Assignment";
import UserIcon from "@mui/icons-material/PersonOutlined";
import SchoolIcon from "@mui/icons-material/SchoolOutlined";
import LogoutIcon from "@mui/icons-material/LoginOutlined";
import ListOutlinedIcon from "@mui/icons-material/ListOutlined";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import NotificationAddOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import portalSettingsManager from "utils/portalSettingsManager";
import { Basket } from "components/ibf-components/booking-journey-components/basket/basket";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store";
import _ from "lodash";
import { ProductBasket } from "store/bookingJourney";
import { handleNewLearningRequestClick } from "utils/helpers";

const Action = withStyles(() => ({
  root: {
    color: "black",
    display: "flex",
    alignItems: "center",
    justifyContent: "left",
    textTransform: "none",
    textAlign: "left",
    "& div": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    "& svg": {
      marginRight: "10px",
    },
  },
}))(Button);
(Action as any).displayName = "Action";

type MyLearningProps = {
  onClick: (val: string) => void;
  showNotification: boolean;
  showAttendanceLink: boolean;
  showServiceNowMenu: boolean;
  newNotificationCount?: number;
  products: ProductBasket[];
  setOpenNotification: (val: boolean) => void;
  setMobileProfileDrawerOpen: (isDrawerOpen: boolean) => void;
  onOpenNewLearningStepSurvey: () => void;
  setbasketContentDrawerOpen: (isDrawerOpen: boolean) => void;
};

export const MyLearningMobile = ({
  onClick,
  showNotification,
  showAttendanceLink,
  showServiceNowMenu,
  newNotificationCount,
  products,
  setOpenNotification,
  setMobileProfileDrawerOpen,
  setbasketContentDrawerOpen,
  onOpenNewLearningStepSurvey,
}: MyLearningProps): React.ReactElement => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [basketQuantity, setBasketQuantity] = useState<number>(0);

  const basket = useSelector((state: RootState) => state.bookingJourney.basket);
  useEffect(() => {
    setBasketQuantity(_.sumBy(basket.products, (p) => p.quantity));
  }, [basket]);

  const handleNavigate = (path: string) => {
    if (location.pathname !== path) {
      navigate(path);
    }
    setMobileProfileDrawerOpen(false);
  };

  return (
    <div className={classes.root}>
      <div>
        {portalSettingsManager?.application?.features?.enableMyLearningForIBF && (
          <Action
            aria-label={t("my_learning")}
            fullWidth
            onClick={() => handleNavigate(MyLearning_Link_Paths.MyLearning)}
          >
            <SchoolIcon></SchoolIcon>
            {t("my_learning")}
          </Action>
        )}
        <Action
          aria-label={t("my_bookings")}
          fullWidth
          onClick={() => handleNavigate("/mybookings")}
        >
          <EventNoteOutlinedIcon></EventNoteOutlinedIcon>
          {t("my_bookings")}
        </Action>
        <Action
          aria-label={t("profile")}
          fullWidth
          onClick={() => handleNavigate(MyLearning_Link_Paths.Profile)}
        >
          <UserIcon></UserIcon>
          {t("profile")}
        </Action>
        {showNotification && (
          <Action
            aria-label={t("notifications")}
            fullWidth
            onClick={() => setOpenNotification(true)}
          >
            <Badge variant="dot" color="secondary" className={classes.MobileBadgeStyle}>
              <NotificationAddOutlinedIcon className={classes.MobileNotificationIcon} />
            </Badge>

            {`${t("notifications")} (${newNotificationCount})`}
          </Action>
        )}
        <Action
          aria-label={t("learning_request")}
          fullWidth
          onClick={() => handleNewLearningRequestClick(onOpenNewLearningStepSurvey, handleNavigate)}
        >
          <AssignmentIcon></AssignmentIcon>
          {t("learning_request")}
        </Action>
        {showServiceNowMenu && (
          <Action
            aria-label={t("incident_management")}
            fullWidth
            onClick={() => onClick(HEADER_CLICK_TYPES.SERVICENOW)}
          >
            <AnalyticsOutlinedIcon></AnalyticsOutlinedIcon>
            {t("incident_management")}
          </Action>
        )}
        {showAttendanceLink && (
          <Action
            aria-label={t("manage_attendance_completion_menu")}
            fullWidth
            onClick={() => handleNavigate(MyLearning_Link_Paths.AttendanceConfirmation)}
          >
            <ListOutlinedIcon></ListOutlinedIcon>
            {t("manage_attendance_completion_menu")}
          </Action>
        )}
        <Action
          aria-label={t("contact_us")}
          fullWidth
          onClick={() => onClick(HEADER_CLICK_TYPES.CONTACTUS)}
        >
          <TelegramIcon></TelegramIcon>
          {t("contact_us")}
        </Action>
        {portalSettingsManager?.application?.features?.enableBookingJourney && (
          <Action
            aria-label={`${t("basket")} ${t("quantity")} ${basketQuantity}`}
            onClick={() => setbasketContentDrawerOpen(true)}
            fullWidth
          >
            <Basket products={products} isMobileView={true}></Basket>
          </Action>
        )}
        <Action
          aria-label={t("log_out")}
          fullWidth
          onClick={() => onClick(HEADER_CLICK_TYPES.LOGOUT)}
        >
          <LogoutIcon></LogoutIcon>
          {t("log_out")}
        </Action>
      </div>
    </div>
  );
};
